// extracted by mini-css-extract-plugin
export default {"item":"ProductItem_item__TCrz2","price":"ProductItem_price__Nsd8m","actions":"ProductItem_actions__+UGXB"};